<br>
<style>
  .p-inputtext.ng-invalid.ng-touched {
    border-color: red !important;
  }
  .primaryEmail {
    border: 1px solid red;
  }

  .p-dropdown.ng-invalid.ng-touched:not(form)>div {
    border: 1px solid red;
  }

</style>
<div>
  <section>
    <div class="row" *ngIf="showAlertMessage">
        <div class="col-md-1"></div>
        <div class="col-md-10">
            <div class="card p-p-2"
                style="border-left-color: red;border-left-style: solid;border-left-width: 5px;border-right-color: red;border-right-style: solid; border-right-width: 5px;">
                <span class="text-nomal text-danger p-text-center">{{alertMessage}}</span>
               
            </div>
           
        </div>
        <div class="col-md-1"></div>
    </div>
  </section>
  <div class="container-fluid"> 
    <div class="row"> 
      <div class="col col-lg-4"></div>    
      <div class="col-md-auto col-lg-4">   
        <br>    
        <div class="card" style=" margin: auto;width: 100%;border: 3px solid transparent;padding: 10px;">
          <div class="font-weight-bold mt-2" style="text-align: center;">
            <span class="title text-lg sign-in-line">Log In</span><br>
          </div>
          <div class="devcare-card-body">
            <div *ngIf="IsDisplay">
              <form [formGroup]="loginUForm">
                <div class="p-fluid p-col-12 ">
                  <br>
                  <span class="p-float-label">
                    <input type="text" id="inputtext" pInputText formControlName="userName"><br>
                    <label for="Username" class="mb-1">Email</label>
                </span>
                 <div *ngIf="errorMessage !='Your UserProfile Not Activated.!'"class="text-center" class="error">{{errorMessage}}</div>     
                 <span class="text-danger"
                 *ngIf="(loginUFormControl.userName.touched) && loginUFormControl.userName.errors?.required">
                </span>
                <span class="text-danger"
                *ngIf="loginUFormControl.userName.touched && loginUFormControl.userName.errors?.email">&nbsp;&nbsp;Please Enter Valid Email address
                </span>                              
                </div>            
                <div class="p-fluid p-col-12">
                  <button pButton type="button" label="Login" [disabled]="!loginUForm.valid"  (click)="onCheckUserName(loginUForm)"
                    class="btn-login"></button>
                </div><br>
                <!-- <p class="text-center text-grey">New to our platform?<span class="text-violet"> <a
                  [routerLink]="['/register-profile']" class="text-primary">
                  Register
                </a></span></p> -->
              </form>
             
            </div>

            <div *ngIf="!IsDisplay">
            <form [formGroup]="loginForm">
              <div class="p-fluid p-col-12">
                <label for="userName">Email</label>
                <input type="email" formControlName="userName" pInputText/>
              </div>
              <span class="text-danger"
              *ngIf="(loginFormControl.userName.touched) && loginFormControl.userName.errors?.required">
             </span>
             <span class="text-danger"
             *ngIf="loginFormControl.userName.touched && loginFormControl.userName.errors?.email">
             &nbsp;&nbsp;Please Enter Valid Email address
             </span>
              <div class="p-fluid p-col-12">
                <div class="row">
                  <div class="p-col-6">
                    <label for="username">Password</label>
                  </div>                 
                </div>                
                <p-password [(ngModel)]="password" [toggleMask]="true" id="password"  formControlName="password" [feedback]="false">                 
                </p-password>
              </div>
              <span class="text-danger"
              *ngIf="(loginFormControl.password.touched) && loginFormControl.password.errors?.required">&nbsp;&nbsp;Password is required
             </span>
             <!-- <span class="text-danger"
              *ngIf="(loginFormControl.password.touched) && loginFormControl.password.errors?.minlength">
              Minimum 8 characters required
             </span> -->
             <div class="p-fluid p-col-12">
              <div class="row p-2">               
                  <label for="password"> Company Id</label>
                  <input type="text" formControlName="companyProfileId" pInputText/>                           
              </div>              
            </div>
            <span class="text-danger p-2"
            *ngIf="(loginFormControl.companyProfileId.touched) && loginFormControl.companyProfileId.errors?.required">
            Please enter valid Company ID
           </span>
           <app-captcha [config]="captchaConfig" (captchaCode)="captchaCode($event)"></app-captcha>
           <div class="p-fluid p-col-12 ">
            <span class="row p-2">
              <label class="mb-1">Captcha</label>
              <input type="text"  pInputText formControlName="captcha" minlength="6" maxlength="6"><br>
            </span>
          </div>
           <!-- <span class="text-danger p-2"
            *ngIf="(loginFormControl.companyProfileId.touched) && loginFormControl.companyProfileId.errors?.minlength">
            Minimum 5 characters required
           </span> -->
              <div class="p-fluid p-col-12">
                <button pButton type="button" label="Login" [disabled]="!loginForm.valid" (click)="onUserLogin(loginForm)"
                  class="btn-login"></button>
              </div>
              <br>            
              <div class="p-fluid p-2">
                <div class="row">
                  <div class="p-col-6 col-md-6 col-sm-6">
                   <span class="text-violet float-left"> <a
                     [routerLink]=""  (click)="forgetPassword()" class="text-primary">
                     Forgot Password?
                   </a></span>
                  </div>
                  <div class="p-col-6 col-md-6 col-sm-6">
                   <!-- <span class="text-violet float-right"> <a
                     [routerLink]="['/register-profile']" class="text-primary">
                     Register 
                   </a></span> -->
                  </div>
                </div>
               </div>
            </form>
            <br>
            </div>
          </div>
        </div>    
        <br> 
      </div>
      <div class="col col-lg-4"></div>  

    </div>
  </div>
</div>
<section>
  <div class="row fixedPhone">           
      <div class="col" *ngIf="!isFloatingContact">
          <button pTooltip="" tooltipPosition="left" style="transform: rotate(90deg);margin-right: -40px;" icon="fas fa-envelope" pButton class="p-button p-button-raised" label="Contact us" (click)="showContact()"></button>
      </div>
      <div class="col" *ngIf="isFloatingContact">
          <div class="card" style="border-right-style: solid;border-right-width: 5px;border-right-color: #41256e;
          border-left-style: solid;border-left-width: 5px;border-left-color: #41256e;">
          <div class="card-header bg-white" style="border: none;">
          <div class="card-title mr-2"><span class="text-dark text-left">If you have any queries, please contact us at</span></div>
          <div class="card-tools">
          <span class=""><i class="fas fa-times p-2 text-dark" (click)="showContact()" style="border-radius: 71%;height: 26px;"></i></span>
          </div>
          </div>
          <div class="card-footer text-center bg-white">
          <span class="font-weight-bold" style="color: #41256e;"><i class="fas fa-envelope"></i> dvmsadmin@devcare.com</span>
          </div>
          </div>                       
      </div>
  </div>
</section>
<p-toast position="bottom-center"></p-toast>
<div class="container-fluid">
  <p-dialog id="alert-box" [(visible)]="isAlertBanner" [modal]="true" [draggable]="false"
  [closable]="false" [resizable]="false">      

  <div class="p-d-flex p-jc-center p-m-2">
    <div>
      <span class="font-weight-bold "><i class="pi pi-exclamation-triangle text-danger" style="font-size: 60px;"></i></span>
    </div>     
  </div>
  <div class="p-d-flex p-jc-center p-m-1">
  <div>
    <span class="text-center text-lg">The DVMS is momentarily unavailable due to an unforeseen technical issue. </span>
  </div>
  </div>
  <div class="p-d-flex p-jc-center p-m-1">
    <div>
      <span class="text-center text-lg">We'll be up and running in no time, so please check back soon!</span>
    </div>
    </div>
</p-dialog>
</div>

